



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';

const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    name: 'LinkShareDialog',
    components: {
        CardTitle,
    },
    directives: {},
})
export default class AppsShareLink extends Vue {
    private copiedTooltip = false;
    private show = false;   
    private homepage = false
    @Prop()
    shareForm: string;

    @Prop()
    showHomepage: boolean

    @Prop()
    appUrl: string;
    
    @Watch('show')
    private onChangeShow() {
        this.homepage = false;
    }

    get currentUrl() {
        return workspaceOptionsModule.currentUrl;
    }

    get generatedLink() {
        let link = '';
        link = `http${window.location.hostname === 'localhost' ? '' : 's'}://${
            window.location.host
        }`;
        //let path = this.currentUrl.path.replace('/app/', '/app2/');
        console.log(this.currentUrl.path)
        link = `${link}/app2${this.currentUrl.path}${this.currentUrl.params}`;
        link = `${link}&homepage=${this.homepage}&pinnedLeft=true`
        return link;
    }
    private copy() {
        this.copiedTooltip = true;
        setTimeout(() => (this.copiedTooltip = false), 3000);
    }
}
